import { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { enrollmentApi } from "api/enrollment";
import DistributorInfoSection from "components/common/sections/DistributorInfoSection";
import { useApp } from "contexts/AppContext";
import { useForm } from "contexts/FormContext";
import { resolveCnLocaleId } from "helpers/language";
import CnFormAccountAddressSection from "./CnFormAccountAddressSection";
import CnFormShippingAddressSection from "./CnFormShippingAddressSection";

export default function CnForm({ data, market }) {
  const {
    state: { rep },
  } = useApp();
  const { form } = useForm();

  const [states, setStates] = useState([]);
  const [shipCities, setShipCities] = useState([]);
  const [shipCounties, setShipCounties] = useState([]);
  const [billCities, setBillCities] = useState([]);
  const [billCounties, setBillCounties] = useState([]);

  const localeId = resolveCnLocaleId(rep?.DefaultLocaleID);

  useEffect(() => {
    if (!localeId) {
      return;
    }

    const loadStates = async () => {
      const options = await enrollmentApi.getStates({ localeId });
      setStates(options);
    };

    loadStates();
  }, [localeId]);

  useEffect(() => {
    if (!localeId || isEmpty(form.ShipState)) {
      setShipCities([]);
      return;
    }

    const loadCities = async () => {
      const options = await enrollmentApi.getCities({
        localeId,
        selectedProvince: form.ShipState,
      });
      setShipCities(options);
    };

    loadCities();
  }, [localeId, form.ShipState]);

  useEffect(() => {
    if (!localeId || isEmpty(form.ShipState) || isEmpty(form.ShipCity)) {
      setShipCounties([]);
      return;
    }

    const loadCounties = async () => {
      const options = await enrollmentApi.getCounties({
        localeId,
        selectedProvince: form.ShipState,
        selectedCity: form.ShipCity,
      });
      setShipCounties(options);
    };

    loadCounties();
  }, [localeId, form.ShipState, form.ShipCity]);

  useEffect(() => {
    if (!localeId || isEmpty(form.BillState)) {
      setBillCities([]);
      return;
    }

    const loadCities = async () => {
      const options = await enrollmentApi.getCities({
        localeId,
        selectedProvince: form.BillState,
      });
      setBillCities(options);
    };

    loadCities();
  }, [localeId, form.BillState]);

  useEffect(() => {
    if (!localeId || isEmpty(form.BillState) || isEmpty(form.BillCity)) {
      setBillCounties([]);
      return;
    }

    const loadCounties = async () => {
      const options = await enrollmentApi.getCounties({
        localeId,
        selectedProvince: form.BillState,
        selectedCity: form.BillCity,
      });
      setBillCounties(options);
    };

    loadCounties();
  }, [localeId, form.BillState, form.BillCity]);

  const { reference2, reference5, reference6 } = data.fields;
  const { text3: sameAddressLabel } = reference6?.fields || {};

  return (
    <>
      <DistributorInfoSection data={reference2} market={market} />
      <CnFormShippingAddressSection
        states={states}
        cities={shipCities}
        counties={shipCounties}
        data={reference6}
      />
      <CnFormAccountAddressSection
        states={states}
        cities={billCities}
        counties={billCounties}
        data={reference5}
        checkboxLabel={sameAddressLabel}
      />
    </>
  );
}
